const isPWA = (): boolean => {
  if ('standalone' in window.navigator && window.navigator.standalone) {
    return true;
  }
  const displayModes = ['fullscreen', 'standalone', 'minimal-ui'];
  return displayModes.some(
    (displayMode) => window.matchMedia(`(display-mode: ${displayMode})`).matches
  );
};

export default isPWA;
